
import { Vue, Component, Prop } from 'vue-property-decorator';

import { SpinningBlock } from '@/components/sports/spinning-texts';

@Component({ name: 'SportSpinningText' })
export default class SportSpinningText extends Vue {
	@Prop({ required: true }) spinningText: SpinningBlock[];
}
